class CmsCarousel {
  constructor(root) {
    this.root = root;
    this.carousel = root.querySelector('.cms-carousel--scrollable');
    if (!this.carousel) return;

    this.track = this.carousel.querySelector('.cms-track');
    this.prevBtn = this.carousel.querySelector('.cms-arrow--prev');
    this.nextBtn = this.carousel.querySelector('.cms-arrow--next');
    this.dotsWrap = root.querySelector('.cms-dots');
    this.step = parseInt(root.dataset.step || '2', 10);
    this.cards = Array.from(this.track.querySelectorAll('.cms-card'));

    this.buildDots();
    this.bindEvents();
    this.updateState();
  }

  cardStep() {
    if (this.cards.length < 2) return 0;
    const a = this.cards[0].getBoundingClientRect();
    const b = this.cards[1].getBoundingClientRect();
    return b.left - a.left; // card width + gap
  }

  buildDots() {
    if (!this.dotsWrap) return;
    this.dotsWrap.innerHTML = '';
    const totalPages = Math.max(1, Math.ceil(this.cards.length / this.step));
    this.dotButtons = [];
    for (let i = 0; i < totalPages; i++) {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.setAttribute('aria-label', `Go to product group ${i + 1}`);
      dot.addEventListener('click', () => this.scrollToPage(i));
      this.dotsWrap.appendChild(dot);
      this.dotButtons.push(dot);
    }
  }

  scrollToPage(pageIndex) {
    const distance = this.cardStep() * this.step * pageIndex;
    this.track.scrollTo({ left: distance, behavior: 'smooth' });
  }

  bindEvents() {
    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', () => {
        this.track.scrollBy({ left: -this.cardStep() * this.step, behavior: 'smooth' });
      });
    }
    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', () => {
        this.track.scrollBy({ left: this.cardStep() * this.step, behavior: 'smooth' });
      });
    }

    let scrollTimer;
    this.track.addEventListener('scroll', () => {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(() => this.updateState(), 80);
    });

    window.addEventListener('resize', () => this.updateState());
  }

  updateState() {
    const step = this.cardStep();
    if (step === 0) return;

    const maxScroll = this.track.scrollWidth - this.track.clientWidth;
    const current = this.track.scrollLeft;

    if (this.prevBtn) this.prevBtn.disabled = current <= 2;
    if (this.nextBtn) this.nextBtn.disabled = current >= maxScroll - 2;

    if (this.dotButtons && this.dotButtons.length) {
      const pageWidth = step * this.step;
      const activeIndex = Math.min(
        this.dotButtons.length - 1,
        Math.round(current / pageWidth)
      );
      this.dotButtons.forEach((dot, i) => dot.classList.toggle('is-active', i === activeIndex));
    }
  }
}

class CmsCardImageCarousel {
  constructor(track) {
    this.track = track;
    const card = track.closest('.cms-card');
    this.dots = card ? Array.from(card.querySelectorAll('[data-card-dots] span')) : [];
    if (!this.dots.length) return;
    this.bindEvents();
  }

  bindEvents() {
    // No debounce, no threshold — update on every scroll frame so the dot
    // moves in sync with the finger during the swipe, not after it settles.
    this.track.addEventListener('scroll', () => this.updateActive(), { passive: true });
  }

  updateActive() {
    const width = this.track.clientWidth;
    if (!width) return;
    // scrollLeft / width gives fractional position; round to nearest dot
    const index = Math.min(
      this.dots.length - 1,
      Math.round(this.track.scrollLeft / width)
    );
    this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
  }
}

function initCmsCardCarousels() {
  document.querySelectorAll('[data-card-image-track]').forEach((track) => {
    if (track.dataset.cardCarouselInit) return;
    track.dataset.cardCarouselInit = 'true';
    new CmsCardImageCarousel(track);
  });
}

function initCmsSections() {
  document.querySelectorAll('[data-cms-section]').forEach((root) => {
    if (root.dataset.cmsInitialized) return;
    root.dataset.cmsInitialized = 'true';
    new CmsCarousel(root);
  });
  initCmsCardCarousels();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCmsSections);
} else {
  initCmsSections();
}

document.addEventListener('shopify:section:load', initCmsSections);